import {
  getPlaceDetailsForPropertyEngine
} from "./chunk-26UMDPK3.js";
import {
  createSessionToken
} from "./chunk-26L2DNU7.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getPropertyEnginePlaceDetails/getPropertyEnginePlaceDetails.ts
async function getPropertyEnginePlaceDetails(placeId, { language, sessionToken }, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getPropertyEnginePlaceDetails");
    const result = await getPlaceDetailsForPropertyEngine(
      {
        placeId,
        language,
        sessionToken: sessionToken ?? createSessionToken()
      },
      _apiConfig
    );
    return {
      status: "success",
      data: result
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getPropertyEnginePlaceDetails
};
